import React from 'react';
import { ArrowRightIcon, CompassIcon, HeartHandshakeIcon, MountainIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { AboutPageHero } from '../components/AboutPageHero';
const values = [{
  icon: MountainIcon,
  title: 'Raised in the Himalaya',
  text: 'Our perspective is shaped by the villages, trails, seasons, and families of the Manaslu region—not by an itinerary designed from afar.'
}, {
  icon: HeartHandshakeIcon,
  title: 'Guests become neighbours',
  text: 'We travel with care for the people who host us, choosing local lodges, local crews, and meaningful encounters over hurried sightseeing.'
}, {
  icon: CompassIcon,
  title: 'Responsibility in practice',
  text: 'Small groups, thoughtful logistics, fair employment, and low-impact trail habits are built into every departure.'
}];
export function WhoWeArePage() {
  return <main className="w-full bg-[#f7f4ed] text-[#233a32]" data-id="element-702" data-mp="257vqac3irlsh">
      <AboutPageHero eyebrow="Our story" title="Rooted in Manaslu. Guided by care." description="Manaslu Trekking is a locally led team creating considered Himalayan journeys with a deep respect for place, people, and pace." imageUrl="https://images.unsplash.com/photo-1544735716-392fe2489ffa?auto=format&fit=crop&w=2000&q=85" data-id="element-703" data-mp="259gl82tqx6qv" />

      <section className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-704" data-mp="271hk793aep78">
        <div className="grid gap-12 lg:grid-cols-[0.82fr_1.18fr] lg:gap-20" data-id="element-705" data-mp="1jalvwly1ic4q">
          <p className="font-serif text-3xl leading-tight text-[#233a32] sm:text-4xl" data-id="element-706" data-mp="1fa1ydh9k16i2">
            We believe the finest way to know the Himalaya is to be welcomed
            into it—slowly, honestly, and with people who call it home.
          </p>
          <div className="space-y-6 text-base leading-8 text-[#53645b]" data-id="element-707" data-mp="1o8x5qwoc4mmy">
            <p data-id="element-708" data-mp="10jubmpcil1bk">
              Our work began with a simple conviction: trekking can create
              genuine value when it is led locally and planned thoughtfully. We
              bring together experienced mountain guides, trusted lodge
              partners, cooks, porters, and operations specialists from across
              Nepal.
            </p>
            <p data-id="element-709" data-mp="35dvg2ylq7tpx">
              Every Manaslu journey is designed around the rhythm of the
              mountains. We leave room for acclimatisation, changing weather,
              village celebrations, and the conversations that turn a route into
              a real experience.
            </p>
            <p data-id="element-710" data-mp="2criz9jdwiaue">
              From the first call to the final descent, our team is present,
              accountable, and invested in making your journey both
              extraordinary and respectful.
            </p>
          </div>
        </div>
      </section>

      <section className="border-y border-[#d9d0bf] bg-[#efe9dc]" data-id="element-711" data-mp="2qqipgvh2axso">
        <div className="mx-auto grid max-w-6xl gap-0 px-6 py-4 md:grid-cols-3" data-id="element-712" data-mp="1xwo4gnp6vqr">
          {values.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="border-[#d9d0bf] py-9 md:px-9 md:first:pl-0 md:not(:last-child):border-r" data-id="element-713" data-mp="5wx6xz66dydr">
              <Icon className="mb-5 h-5 w-5 text-[#9a7b3e]" aria-hidden="true" data-id="element-714" data-mp="1mexiybs56rz0" />
              <h2 className="font-serif text-2xl text-[#233a32]" data-id="element-715" data-mp="1hmwbr49tzrfu">{title}</h2>
              <p className="mt-3 text-sm leading-7 text-[#53645b]" data-id="element-716" data-mp="1cobad1iuf1pt">{text}</p>
            </article>)}
        </div>
      </section>

      <section className="mx-auto max-w-5xl px-6 py-16 sm:py-24" data-id="element-717" data-mp="17o6pkzawjkts">
        <div className="border-l-2 border-[#a98b50] pl-6 sm:pl-8" data-id="element-718" data-mp="12qezmatti8s8">
          <p className="font-serif text-2xl leading-relaxed text-[#233a32] sm:text-3xl" data-id="element-719" data-mp="yp36vwfnd7ft">
            “We measure a successful trek not only by a safe crossing of the
            pass, but by the respect our guests carry home.”
          </p>
          <p className="mt-5 text-xs font-semibold uppercase tracking-[0.2em] text-[#9a7b3e]" data-id="element-720" data-mp="2t345cg7absfd">
            The Manaslu Trekking team
          </p>
        </div>
        <Link to="/about/why-choose-us" className="mt-12 inline-flex items-center gap-2 border-b border-[#9a7b3e] pb-2 text-sm font-semibold uppercase tracking-[0.16em] text-[#233a32] transition-colors hover:text-[#9a7b3e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#9a7b3e] focus-visible:ring-offset-4" data-id="element-721" data-mp="1kt3z5pf7h0pd">
          Discover our approach{' '}
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-722" data-mp="123e554j9oiyi" />
        </Link>
      </section>
    </main>;
}